import CancelModalButton from "../../UIElements/CustomModal/CancelModalButton";

import SelectEstablishement  from "../../Forms/SelectEstablishement";
import { useLocalStorage } from "../../../hooks";
import { AuthUser, Session, User } from "../../../types";
import { sessionStorageKey } from "../../../consts";
import { useState } from "react";
import { getUserByEstablishmentId } from "../../../services/user.service";
import { Box, Button } from "@mui/material";
import CustomButton from "../../UIElements/CustomButton";

export default function ModalContentLogAs(){

    const { setValue, deleteValue, storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);
    const {
        auth: { user: currentUser },
    } = session;
    
    const [selectedUser, setSelectedUser] = useState<AuthUser | null>(null);
    
    const handleSelect = async (selectedValue: string) => {
        try {
          // Convert selectedValue to number (assuming it's the establishment ID)
          const establishmentId = Number(selectedValue);
          // Fetch user data by establishment ID
          const user = await getUserByEstablishmentId(establishmentId);
    
          // Set the fetched user data into state
          setSelectedUser(user);
        } catch (error) {
          console.error('Error fetching user by establishment ID:', error);
        }
      };
    const handleSubmit = () => {
        if (null !== selectedUser){
            session.auth.userAdmin = session.auth.user;
            session.auth.user = selectedUser;
            setValue(session);
            window.location.reload();
        }
    }
    return (
        <Box
      component="form"
      onSubmit={handleSubmit}
      noValidate
      sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
    >
          
                <SelectEstablishement 
                    groupId={currentUser.establishmentGroup}
                    regionId={currentUser.region}
                    onSelect={handleSelect}
                />
            <CustomButton
                type="submit"
                label="Valider"
                customsx={{
                    "@media (max-width:1024px)": {
                        width: "100%",
                    },
                }}
            />
            <CancelModalButton
                customsx={{
                    width: "100%",
                }}
            />

        </Box>
    )
}